import moment from 'moment';

const getTripInstanceKey = trip =>
  `${trip.id}::${moment(trip.departureTime).format('YYYY-MM-DD')}`;

export default getTripInstanceKey;
